import { ConsultantDocumentAgregator } from './components/ConsultantsDocuments/ConsultantDocumentAgregator/ConsultantDocumentAgregator';
import { Consultant, ConsultantDocument, ConsultantInvoice, PeppolSendedDoc } from './interfaces/Consultant';
import { Contact } from './interfaces/Contact';
import { Customer } from './interfaces/Customer';
import * as Data from './store/Data';
import { Project } from './store/Data';

export const SortHelper = {
    ConsultantByName: (a: Consultant, b: Consultant): number => {
        const nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
        const nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    },
    productByName: (a: Data.Product, b: Data.Product): number => {
        const nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
        const nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    },
    articleByName: (a: Data.Article, b: Data.Article): number => {
        const nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
        const nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    },
    CustomerByName: (a: Customer, b: Customer): number => {
        const nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
        const nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    },
    Contacts: (a: Contact, b: Contact): number => {
        const nameA = (a.firstName ? a.firstName.toUpperCase() : "") + (a.lastName ? a.lastName.toUpperCase() : ""); // ignore upper and lowercase
        const nameB = (b.firstName ? b.firstName.toUpperCase() : "") + (b.lastName ? b.lastName.toUpperCase() : ""); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    },
    ProjectByName: (a: Data.Project, b: Data.Project): number => {
        const nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
        const nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    },
    ProjectByCustomerThenDisplayName: (customers: Customer[] | undefined, a: Data.Project, b: Data.Project): number => {
        if (a.customerid === b.customerid) {
            const nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
            const nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
        }
        if (customers) {
            const ca = customers.find(x => x.customerid === a.customerid);
            const cb = customers.find(x => x.customerid === b.customerid);
            const nameA = ca && ca.displayName ? ca.displayName.toUpperCase() : ""; // ignore upper and lowercase
            const nameB = cb && cb.displayName ? cb.displayName.toUpperCase() : ""; // ignore upper and lowercase
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
        }
        return 0;
    },
    ProjectAssigmentByName: (a: Data.ProjectAssigment, b: Data.ProjectAssigment): number => {
        const nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
        const nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    },
    ProjectAssigmentByCustomerThenDisplayName: (projects: Project[] | undefined, customers: Customer[] | undefined, a: Data.ProjectAssigment, b: Data.ProjectAssigment): number => {
        if (projects && customers) {
            const pa = projects.find(x => x.projectid === a.projectid);
            const pb = projects.find(x => x.projectid === b.projectid);

            if (pa && pb) {
                if (pa.customerid === pb.customerid) {
                    let nameA = pa.displayName ? pa.displayName.toUpperCase() : ""; // ignore upper and lowercase
                    let nameB = pb.displayName ? pb.displayName.toUpperCase() : ""; // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
                    nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                }
                else {
                    const ca = customers.find(x => x.customerid === pa.customerid);
                    const cb = customers.find(x => x.customerid === pb.customerid);
                    const nameA = ca && ca.displayName ? ca.displayName.toUpperCase() : ""; // ignore upper and lowercase
                    const nameB = cb && cb.displayName ? cb.displayName.toUpperCase() : ""; // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                }
            }
            else {
                if (pa === undefined) console.log("projects not found a", a);
            }
        }
        else {
            console.log("Data no available");
        }
        return 0;
    },
    InvoiceByName_Desc: (a: Data.Invoice, b: Data.Invoice): number => {
        const nameA = a.invoiceRef ? a.invoiceRef.toUpperCase() : ""; // ignore upper and lowercase
        const nameB = b.invoiceRef ? b.invoiceRef.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA > nameB) {
            return -1;
        }
        if (nameA < nameB) {
            return 1;
        }
        return 0;
    },
    InvoiceTemplateByOrder: (a: Data.InvoiceTemplate, b: Data.InvoiceTemplate): number => {
        if (a.order < b.order) {
            return -1;
        }
        if (a.order > b.order) {
            return 1;
        }
        return 0;
    },
    ConsultantInvoiceByPeriode_Desc: (a: ConsultantInvoice, b: ConsultantInvoice): number => {
        const sl1: number = a.periode ? (new Date(a.periode)).getTime() : Date.now();
        const sl2: number = b.periode ? (new Date(b.periode)).getTime() : Date.now();
        if (sl1 < sl2) {
            return 1;
        }
        if (sl1 > sl2) {
            return -1;
        }
        return 0;
    },
    ArticlesByName_Desc: (a: Data.Article, b: Data.Article): number => {
        const nameA = a.displayName ? a.displayName.toUpperCase() : ""; // ignore upper and lowercase
        const nameB = b.displayName ? b.displayName.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA > nameB) {
            return -1;
        }
        if (nameA < nameB) {
            return 1;
        }
        return 0;
    },
    TimeSheetByDate_Desc: (a: Data.TimeSheetEntry, b: Data.TimeSheetEntry): number => {
        const sl1: number = a.date !== null ? (new Date(a.date)).getTime() : Date.now();
        const sl2: number = b.date !== null ? (new Date(b.date)).getTime() : Date.now();
        if (sl1 < sl2) {
            return 1;
        }
        if (sl1 > sl2) {
            return -1;
        }
        return 0;
    },
    SellByDate_Desc: (a: Data.Sale, b: Data.Sale): number => {
        const sl1: number = a.date ? (new Date(a.date)).getTime() : Date.now();
        const sl2: number = b.date ? (new Date(b.date)).getTime() : Date.now();
        if (sl1 < sl2) {
            return 1;
        }
        if (sl1 > sl2) {
            return -1;
        }
        return 0;
    },
    ConsultantDocumentByDate: (a: ConsultantDocument, b: ConsultantDocument): number => {
        const sl1: number = a.documentDate ? (new Date(a.documentDate)).getTime() : Date.now();
        const sl2: number = b.documentDate ? (new Date(b.documentDate)).getTime() : Date.now();
        if (sl1 < sl2) {
            return 1;
        }
        if (sl1 > sl2) {
            return -1;
        }
        return 0;
    },
    ConsultantDocumentAgregatorByDate: (a: ConsultantDocumentAgregator, b: ConsultantDocumentAgregator): number => {
        const sl1: number = a.date.getTime();
        const sl2: number = b.date.getTime();
        if (sl1 < sl2) {
            return 1;
        }
        if (sl1 > sl2) {
            return -1;
        }
        return 0;
    },
    peppolSendedDocs: (a: PeppolSendedDoc, b: PeppolSendedDoc): number => {
        const sl1: number = a.peppoDocSendDate !== null ? (new Date(a.peppoDocSendDate)).getTime() : Date.now();
        const sl2: number = b.peppoDocSendDate !== null ? (new Date(b.peppoDocSendDate)).getTime() : Date.now();
        if (sl1 < sl2) {
            return 1;
        }
        if (sl1 > sl2) {
            return -1;
        }
        return 0;
    },
};